// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RequestEnvironmentSpecComponent
 */
export interface RequestEnvironmentSpecComponent {
  /**
   *
   * @type {string}
   * @memberof RequestEnvironmentSpecComponent
   */
  name?: string;
}

/**
 * Check if a given object implements the RequestEnvironmentSpecComponent interface.
 */
export function instanceOfRequestEnvironmentSpecComponent(
  value: object,
): value is RequestEnvironmentSpecComponent {
  return true;
}

export function RequestEnvironmentSpecComponentFromJSON(
  json: any,
): RequestEnvironmentSpecComponent {
  return RequestEnvironmentSpecComponentFromJSONTyped(json, false);
}

export function RequestEnvironmentSpecComponentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironmentSpecComponent {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function RequestEnvironmentSpecComponentToJSON(
  json: any,
): RequestEnvironmentSpecComponent {
  return RequestEnvironmentSpecComponentToJSONTyped(json, false);
}

export function RequestEnvironmentSpecComponentToJSONTyped(
  value?: RequestEnvironmentSpecComponent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
  };
}
